import { render, staticRenderFns } from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=template&id=2b0babcf&scoped=true"
import script from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-travel-insurance-documents-addons.vue?vue&type=style&index=0&id=2b0babcf&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0babcf",
  null
  
)

export default component.exports